import { type FC, type MouseEvent } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

export interface DashboardAction {
    classes: string;
    icon: IconProp;
    label: string;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
}

interface Props {
    actions: Array<DashboardAction>;
}

export const DashboardActions: FC<Props> = ({
    actions,
}) => {
    return (
        <div
            className={
                "do-not-print fixed top-16 right-0 flex flex-col space-y-3 overflow-hidden z-10 pointer-events-none"
            }
        >
            {actions.map((action, index) => (
                <button
                    key={index}
                    className={
                        "flex translate-x-24 transition-transform duration-300 hover:translate-x-0 " +
                        "items-center p-0 text-lg pointer-events-auto " + (
                            action.disabled ?
                                "bg-neutral-700 text-neutral-500 cursor-not-allowed" :
                                `cursor-pointer text-white ${action.classes}`
                        )
                    }
                    disabled={action.disabled}
                    onClick={action.onClick}
                >
                    <div className="w-12 p-2 text-xl">
                        <FontAwesomeLight icon={action.icon} />
                    </div>
                    <div className="w-24 text-left">
                        {action.label}
                    </div>
                </button>
            ))}
        </div>
    );
};
